// extracted by mini-css-extract-plugin
module.exports = {"root":"_13m94mE","rootScrolled":"_1X78l7z"};